import { Img } from "./..";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import NavbarItem from "./NavbarItem";
import useIsMobile from "utils/useIsMobile";

const data = {
  navBarItems: [
    { title: "Home", ref: "home" },
    { title: "Create your comic", ref: "createComic", link: "formnew" },
    { title: "Pricing", ref: "pricing" },
    { title: "About us", ref: "aboutUs" },
    { title: "Contact", link: "formnew", ref: "contact" },
  ],
};

export default function Header({ refs, ...props }) {
  const isMobile = useIsMobile();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div>
      {!isMobile ? (
        <header
          {...props}
          className={`${props.className} flex justify-start items-center py-6 sm:py-5 bg-white sm:items-start`}
        >
          <div className="flex items-center gap-[81px] px-4 md:px-5 sm:items-start sm:gap-5">
            <Link to="/">
              <Img
                src="images/img_header_logo.svg"
                alt="Headerlogo"
                className="w-[6.4vw] ml-[5vw] md:w-[60px] object-contain sm:h-[32px] sm:w-fit"
              />
            </Link>
            <ul className="flex flex-wrap gap-12">
              {data.navBarItems.map((item, index) => (
                <NavbarItem
                  title={item.title}
                  isLink={item?.link !== undefined}
                  link={item.link}
                  key={"navbaritem" + index}
                  section={refs.current[item.ref]}
                />
              ))}
            </ul>
          </div>
        </header>
      ) : (
        <nav className="border-gray-200 bg-gray-50 dark:bg-gray-800 dark:border-gray-700">
          <div className="max-w-screen-xl w-[90vw] flex flex-wrap items-center justify-between mx-auto p-4">
            <a
              href="/"
              className="flex items-center space-x-3 rtl:space-x-reverse"
            >
              <img
                src="images/img_header_logo.svg"
                className="h-8"
                alt="Lifetoon Logo"
              />
            </a>
            <button
              type="button"
              className="inline-flex items-center justify-center p-2 w-10 h-10 text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
              aria-controls="navbar-hamburger"
              aria-expanded={isMenuOpen}
              onClick={toggleMenu}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
            </button>
            <div
              className={`${isMenuOpen ? "block" : "hidden"} w-full`}
              id="navbar-hamburger"
            >
              <ul className="flex flex-col font-medium mt-4 rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700 gap-4">
                {data.navBarItems.map((item, index) => (
                  <NavbarItem
                    title={item.title}
                    isLink={item?.link !== undefined}
                    link={item.link}
                    key={"navbaritem" + index}
                    section={refs.current[item.ref]}
                  />
                ))}
              </ul>
            </div>
          </div>
        </nav>
      )}
    </div>
  );
}
